import { TagminMainOnTransparentImage as tagminMainOnTransparentPng } from "assets";
import { availabilityCalendarFallback } from "app/store/fallbackTranslations";
import {
  DatePickerType,
  DatePickerUniversalFormik,
  QuestionTooltip,
  TextInputFormik,
} from "component-library";
import { Form } from "formik";
import React, { FC } from "react";
import { dataTestIds } from "data-testids";
import { cleanHtml } from "shared/utils/dom";

const dateEntryHelperProps = {
  title: availabilityCalendarFallback.enterDatesTooltip.header,
  html: availabilityCalendarFallback.enterDatesTooltip.content,
};

interface AvailabilityCalendarFormProps {
  sanitizedTagminLabel?: string;
}

const sanitizedTagminComingSoon = () => {
  return cleanHtml(
    availabilityCalendarFallback.tagminComingSoon.replace(
      "{image}",
      `<img src="${tagminMainOnTransparentPng}" alt="Tagmin Logo" class="object-contain pt-1" />`
    )
  );
};

const AvailabilityCalendarForm: FC<AvailabilityCalendarFormProps> = () => {
  return (
    <Form>
      <div className="flex flex-col mt-6">
        <div className="flex justify-start gap-2">
          <p className="m-0">{availabilityCalendarFallback.datePickerLabel}</p>
          <QuestionTooltip {...dateEntryHelperProps} />
        </div>
        <div className="flex">
          <DatePickerUniversalFormik
            type={DatePickerType.Range}
            whiteInput
            name="selectedUnavailableDates"
            minDate={new Date()}
            data-testid={
              dataTestIds.profile[
                "MainPage.AvailabilityCalendarForm.AvailabilityCalendarForm.datePicker"
              ]
            }
            placeholder={availabilityCalendarFallback.datePickerPlaceholder}
            className="w-full md:w-80"
          />
        </div>
      </div>
      <div>
        <TextInputFormik
          name="title"
          label={availabilityCalendarFallback.titleLabel}
          maxLength={50}
          whiteInput
          data-testid={
            dataTestIds.profile[
              "MainPage.AvailabilityCalendarForm.AvailabilityCalendarForm.titleInput"
            ]
          }
        />
      </div>
      {/* <div>
        <div className="flex gap-4 bg-color-neutral-three p-2.5">
          <CheckBoxFormik
            aria-label={availabilityCalendarFallback.tagminCheckboxLabel}
            name="isTagminSelected"
            value
            white
          />
          <div>
            <div
              className="flex gap-1 m-0 font-bold align-middle"
              dangerouslySetInnerHTML={{
                __html: sanitizedTagminLabel,
              }}
            ></div>
            <p className="m-0">
              {availabilityCalendarFallback.tagminCheckboxDescription}
            </p>
          </div>
        </div>
      </div> */}
      <div
        className="flex gap-1 bg-color-neutral-three p-2.5"
        dangerouslySetInnerHTML={{ __html: sanitizedTagminComingSoon() }}
      ></div>
    </Form>
  );
};

export default AvailabilityCalendarForm;
